import { useAuth as useAuthContext } from '@/contexts/AuthContext';

// Re-export the useAuth hook for convenience
export const useAuth = useAuthContext;
